export default __webpack_public_path__ + "static/about1-3d741eef473bda22a9b50859adcadee7.jpg";